import {
  Button,
  FullscreenModal,
  FullscreenModalContent,
  LoadingIndicator,
} from '@commenda/kakashi';
import { IKeyPersonDetail } from '@commenda/types';
import { useState } from 'react';
import { IncorporationFormHeader } from '../../form-builder/components/new-incorp-layout';
import { KeyPersonForm } from './KeyPersonForm';

const FORM_ID = 'add-edit-key-person-form';

export const AddEditKeyPersonModal = ({
  isOpen,
  onClose,
  companyId,
  keyPerson,
  onSaved,
}: {
  isOpen: boolean;
  onClose: () => void;
  companyId: number;
  /** Present → edit mode: the form is prefilled and submits a PATCH instead of a create. */
  keyPerson?: IKeyPersonDetail;
  onSaved?: (keyPersonId: number) => void;
}) => {
  const isEditing = keyPerson !== undefined;
  // Add mode is submittable immediately; edit mode waits for a change. KeyPersonForm keeps this current.
  const [formState, setFormState] = useState(() => ({
    isSaving: false,
    canSubmit: !isEditing,
  }));

  return (
    <FullscreenModal isOpen={isOpen} onClose={onClose} enableEscapeKey>
      <IncorporationFormHeader onClose={onClose} />
      <FullscreenModalContent className="flex min-h-0 items-start justify-center overflow-y-auto bg-bg-light">
        <div className="flex w-[563px] max-w-full flex-col gap-5xl py-5xl pb-8xl">
          <div className="flex flex-col gap-xs">
            <h1 className="display-xs-bold text-text-primary">
              {isEditing ? 'Edit key person' : 'Add key person'}
            </h1>
            <p className="txt-small-regular text-text-secondary">
              Individuals who play a vital role in your company.
            </p>
          </div>

          {/* Mounted only while open so the form resets on each open and doesn't fetch when hidden. */}
          {isOpen && (
            <KeyPersonForm
              companyId={companyId}
              keyPerson={keyPerson}
              formId={FORM_ID}
              onSaved={(id) => onSaved?.(id)}
              onStateChange={setFormState}
            />
          )}

          <div className="flex items-center justify-end gap-md">
            <Button variant="secondary" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              form={FORM_ID}
              disabled={!formState.canSubmit}
            >
              {formState.isSaving ? <LoadingIndicator size={16} /> : null}
              <span>{isEditing ? 'Save changes' : 'Add key person'}</span>
            </Button>
          </div>
        </div>
      </FullscreenModalContent>
    </FullscreenModal>
  );
};
